import React from 'react';
import classNames from 'classnames';

import classes from '../diversitySection/diversitySection.module.css';

const StatisticsSection = ({ statisticsContentBlurb }) => {
  if (!statisticsContentBlurb?.content) return false;

  return (
    <div
      className={classNames('content-blurb', classes['demographics-statistics-content-blurb'])}
      dangerouslySetInnerHTML={{ __html: statisticsContentBlurb.content }}
    />
  );
};

export default StatisticsSection;
